<template>
  <div>
    <TypeDetailMobile
      v-if="isMobile"
      :other-links="otherLinks"
      :page-description="pageDescription"
      :type="type"
      :title="name"
    />
    <TypeDetailDesktop
      v-else
      :other-links="otherLinks"
      :page-description="pageDescription"
      :type="type"
      :title="name"
      :breadcrumb-links="breadcrumbLinks"
    />
  </div>
</template>

<script>
import {
  getMutualFundTypeObject,
  generateOtherLinks,
  generateBreadcrumbLinks,
  seoMapperConstant as CONSTANT,
} from 'shared/helpers/seoMap';
import isMobile from 'shared/mixins/isMobile';
import TypeDetailMobile from '../../components/mobile/type/TypeDetail';
import TypeDetailDesktop from '../../components/desktop/type/TypeDetail';

export default {
  name: 'TypeDetailPage',
  metaInfo() {
    return {
      title: this.mutualFundTypeObject.meta_title,
      meta: [
        { name: 'description', content: this.mutualFundTypeObject.meta_desc },
        { name: 'keyword', content: this.mutualFundTypeObject.meta_keyword },
      ],
    };
  },
  components: {
    TypeDetailMobile,
    TypeDetailDesktop,
  },
  mixins: [isMobile],
  props: {
    detail: {
      type: String,
      default: null,
    },
  },
  computed: {
    otherLinks() {
      return generateOtherLinks(this.page, CONSTANT.TYPE_KEY);
    },
    pageDescription() {
      return this.mutualFundTypeObject.page_desc;
    },
    type() {
      return this.mutualFundTypeObject.type;
    },
    mutualFundTypeObject() {
      return getMutualFundTypeObject(this.detail);
    },
    page() {
      return this.mutualFundTypeObject.key;
    },
    breadcrumbLinks() {
      return generateBreadcrumbLinks(CONSTANT.TYPE_KEY, this.page);
    },
    name() {
      return this.mutualFundTypeObject.name;
    },
  },
};
</script>
